export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white px-6 py-12" data-testid="terms-page">
      <div className="max-w-lg mx-auto">
        <a href="/invest" data-testid="terms-back-link" className="text-emerald-600 text-sm hover:underline">&larr; Back</a>
        <h1 className="text-[#0b132b] text-2xl font-bold mt-4 mb-6" style={{fontFamily:"'Syne',sans-serif"}}>Terms of Use</h1>
        <div className="text-slate-700 space-y-4 text-sm leading-relaxed">
          <p>These terms apply to the DealDeck investor enquiry page. DealDeck is a trading name of RJL Property Solutions Ltd (NI744060).</p>
          <h2 className="text-[#0b132b] text-lg font-bold mt-6">Enquiries only</h2>
          <p>Submitting the form registers your interest only. It is not an offer, a reservation or a contract, and places no obligation on you or on us.</p>
          <h2 className="text-[#0b132b] text-lg font-bold mt-6">No financial advice</h2>
          <p>Example figures on this page are estimates for illustration and are not available for purchase. Nothing on this page is financial, legal or investment advice. Always carry out your own due diligence and take independent advice before buying property.</p>
          <h2 className="text-[#0b132b] text-lg font-bold mt-6">Sourcing fees</h2>
          <p>Any sourcing fee or reservation deposit is agreed separately in writing before you commit to a specific deal.</p>
          <h2 className="text-[#0b132b] text-lg font-bold mt-6">Your data</h2>
          <p>How we handle your details is explained in our <a href="/privacy" className="text-emerald-600 underline">Privacy Policy</a>.</p>
          <h2 className="text-[#0b132b] text-lg font-bold mt-6">Contact</h2>
          <p>DealDeck<br />Email: james@rjdigitalsolutions.co.uk<br />ICO Registration: ZC034426</p>
          <p className="text-slate-500 text-xs mt-8">Last updated: November 2026</p>
        </div>
      </div>
    </div>
  );
}
